// extracted by mini-css-extract-plugin
export var button = "_n1-0";